/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ImageTests from './image-tests';
import ImageTestsDetail from './image-tests-detail';
import ImageTestsUpdate from './image-tests-update';
import ImageTestsDeleteDialog from './image-tests-delete-dialog';

const ImageTestsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ImageTests />} />
    <Route path="new" element={<ImageTestsUpdate />} />
    <Route path=":id">
      <Route index element={<ImageTestsDetail />} />
      <Route path="edit" element={<ImageTestsUpdate />} />
      <Route path="delete" element={<ImageTestsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ImageTestsRoutes;
